import React from 'react';
import { Typography, Box, Container, Button } from '@mui/material';
import { ActiveTenantsActions } from './ActiveTenantsActions';
import useStyles from './styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
export const TenanciesBatchActions = observer(() => {
  const store = useStore();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Box, {
    className: classes.batchBarWrapper
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: classes.batchBarContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.selectInfo
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    size: "small",
    onClick: () => store.residenciesMultiActionStore.deselectAll(),
    'custom-attribute': '230-TenanciesBatchActions'
  }, "Deselect all"), /*#__PURE__*/React.createElement("div", {
    className: classes.selectCount
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, store.residenciesMultiActionStore.selectedDetails.length, /*#__PURE__*/React.createElement("span", null, store.residenciesMultiActionStore.selectedDetails.length > 1 ? ' residents selected' : ' resident selected')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "light"
  }, "You can continue to select multiply lines to process batch actions."))), /*#__PURE__*/React.createElement(ActiveTenantsActions, null))));
});